import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-16px lg:text-20px xl:text-20px xxl:text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col md:flex-row w-full h-screen py-6  overflow-y-auto"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 w-full gap-8 my-4" }
const _hoisted_7 = { class: "w-full md:w-9/20" }
const _hoisted_8 = { class: "font-semibold text-black-lp-300" }
const _hoisted_9 = { class: "my-1 text-black-lp-300" }
const _hoisted_10 = { class: "w-full md:w-9/20" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300" }
const _hoisted_12 = { class: "my-1 text-gray-lp-300" }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 w-full gap-8 my-4" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300" }
const _hoisted_16 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_17 = {
  key: 0,
  class: "w-full"
}
const _hoisted_18 = { class: "font-semibold text-black-lp-300" }
const _hoisted_19 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_20 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_21 = { class: "w-full " }
const _hoisted_22 = { class: "font-semibold text-black-lp-300" }
const _hoisted_23 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_24 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_25 = { class: "inline-flex gap-2 items-center" }
const _hoisted_26 = { class: "font-semibold flex flex-row items-center" }
const _hoisted_27 = { class: "grid grid-cols-1 md:grid-cols-2 w-full gap-8 my-4" }
const _hoisted_28 = { class: "w-full md:w-9/20" }
const _hoisted_29 = { class: "font-semibold text-black-lp-300" }
const _hoisted_30 = { class: "my-1 text-black-lp-300" }
const _hoisted_31 = { class: "w-full md:w-9/20" }
const _hoisted_32 = { class: "font-semibold text-black-lp-300" }
const _hoisted_33 = { class: "my-1 flex item-start gap-x-4 flex-wrap" }
const _hoisted_34 = { class: "grid grid-cols-1 md:grid-cols-2 w-full gap-8 my-4" }
const _hoisted_35 = { class: "w-full" }
const _hoisted_36 = { class: "font-semibold text-black-lp-300" }
const _hoisted_37 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_38 = {
  key: 0,
  class: "w-full"
}
const _hoisted_39 = { class: "font-semibold text-black-lp-300" }
const _hoisted_40 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_41 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_42 = {
  key: 1,
  class: "w-full"
}
const _hoisted_43 = { class: "font-semibold text-black-lp-300" }
const _hoisted_44 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_45 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_46 = { class: "grid grid-cols-1 md:grid-cols-2 w-full gap-8 my-4" }
const _hoisted_47 = {
  key: 0,
  class: "w-full md:w-9/20"
}
const _hoisted_48 = { class: "font-semibold text-black-lp-300" }
const _hoisted_49 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_50 = {
  key: 1,
  class: "w-full md:w-9/20"
}
const _hoisted_51 = { class: "font-semibold text-black-lp-300" }
const _hoisted_52 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_53 = { class: "text-12px xxl:text-14px border-l-none w-full pl-4 gap-y-8 md:border-l md:w-1/3 md:pl-3 md:border-gray-lp-400" }
const _hoisted_54 = { class: "py-3" }
const _hoisted_55 = { class: "font-semibold text-black-lp-300" }
const _hoisted_56 = { class: "my-1 text-black-lp-300" }
const _hoisted_57 = { class: "flex gap-x-4" }
const _hoisted_58 = { class: "capitalize" }
const _hoisted_59 = { class: "py-3" }
const _hoisted_60 = { class: "font-normal text-gray-lp-800 text-12px mb-2" }
const _hoisted_61 = { class: "my-1 text-black-lp-300" }
const _hoisted_62 = { class: "text-gray-lp-300" }
const _hoisted_63 = { class: "py-3 border-b" }
const _hoisted_64 = { class: "font-normal text-gray-lp-800 text-12px mb-2" }
const _hoisted_65 = { class: "my-1 text-black-lp-300" }
const _hoisted_66 = { class: "text-gray-lp-300" }
const _hoisted_67 = { class: "py-4 flex w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_modal_edit_detail = _resolveComponent("modal-edit-detail")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-5 mr-3 cursor-pointer",
              alt: "back"
            }),
            _createVNode("div", _hoisted_3, _toDisplayString(!_ctx.isError ? _ctx.dataDetail.name : ""), 1)
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchUserData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("userManagement.detail.userId")), 1),
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.dataDetail.id), 1)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("userManagement.detail.username")), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.dataDetail.username), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("userManagement.detail.accountType")), 1),
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.dataDetail.account_type.toLowerCase()), 1)
                  ]),
                  (
              (_ctx.roleAccount === 'internal' || 'customer-service') &&
                _ctx.dataDetail.account_type === 'internal'
            )
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("userManagement.detail.division")), 1),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.dataDetail.division_name || "-"), 1),
                          _createVNode(_component_lp_button, {
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: _ctx.$t('userManagement.detail.edit'),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModalEditDetail('division')))
                          }, null, 8, ["title"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("userManagement.detail.role")), 1),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.dataDetail.role_name), 1),
                      (_ctx.isAbleChangeRole)
                        ? (_openBlock(), _createBlock(_component_lp_button, {
                            key: 0,
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: _ctx.$t('userManagement.detail.edit'),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalEditDetail('role')))
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.isShowAssigned3Lc)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      value: _ctx.displayAssigned3lc
                    }, {
                      label: _withCtx(() => [
                        _createVNode("div", _hoisted_25, [
                          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("userManagement.detail.assignedTo3lc")), 1),
                          _createVNode(_component_lp_button, {
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: _ctx.$t('userManagement.detail.edit'),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModalEditDetail('3lc')))
                          }, null, 8, ["title"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("userManagement.detail.phoneNumber")), 1),
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.dataDetail.phone_number), 1)
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("userManagement.detail.email")), 1),
                    _createVNode("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.dataDetail.email) + " ", 1),
                      _withDirectives(_createVNode(_component_lp_button, {
                        compact: "",
                        "text-color": "red-lp-100",
                        flat: "",
                        title: _ctx.$t('userManagement.detail.edit'),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModalEditDetail('email')))
                      }, null, 8, ["title"]), [
                        [_vShow, _ctx.isAbleChangeEmail]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("userManagement.detail.reference")), 1),
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.dataDetail.client !== undefined
                  ? _ctx.dataDetail.client.company_name
                  : _ctx.dataDetail.partner !== undefined
                  ? _ctx.dataDetail.partner.name
                  : _ctx.dataDetail.vendor !== undefined
                  ? _ctx.dataDetail.vendor.name
                  : "-"), 1)
                  ]),
                  (_ctx.displayHub)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("userManagement.detail.shuttle")), 1),
                        _createVNode("div", _hoisted_40, [
                          _createVNode("div", _hoisted_41, _toDisplayString(_ctx.dataDetail.shuttle_name || "-"), 1),
                          _createVNode(_component_lp_button, {
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: _ctx.$t('userManagement.detail.edit'),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModalEditDetail('shuttle')))
                          }, null, 8, ["title"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.displayHub)
                    ? (_openBlock(), _createBlock("div", _hoisted_42, [
                        _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("userManagement.detail.hub")), 1),
                        _createVNode("div", _hoisted_44, [
                          _createVNode("div", _hoisted_45, _toDisplayString(_ctx.dataDetail.hub.hubName || _ctx.$t("userManagement.detail.noHub")), 1),
                          _createVNode(_component_lp_button, {
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: _ctx.$t('userManagement.detail.edit'),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModalEditDetail('hub')))
                          }, null, 8, ["title"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_46, [
                  (_ctx.dataDetail.account_hub_code)
                    ? (_openBlock(), _createBlock("div", _hoisted_47, [
                        _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("userManagement.detail.hubCode")), 1),
                        _createVNode("div", _hoisted_49, _toDisplayString(_ctx.dataDetail.account_hub_code !== ""
                  ? _ctx.dataDetail.account_hub_code
                  : "-"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.dataDetail.partner?.hub?.hub_name)
                    ? (_openBlock(), _createBlock("div", _hoisted_50, [
                        _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("userManagement.detail.hubName")), 1),
                        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.dataDetail.partner !== undefined &&
                _ctx.dataDetail.partner.hub !== undefined
                  ? _ctx.dataDetail.partner.hub.hub_name
                  : "-"), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_53, [
                _createVNode("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("userManagement.detail.accountStatus")), 1),
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_58, _toDisplayString(_ctx.dataDetail.status.toLowerCase()), 1)
                      ], 2),
                      _withDirectives(_createVNode(_component_lp_button, {
                        compact: "",
                        "text-color": "red-lp-100",
                        flat: "",
                        title: _ctx.$t('userManagement.detail.edit'),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModalEditDetail('status')))
                      }, null, 8, ["title"]), [
                        [_vShow, _ctx.isEditAble]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("userManagement.detail.updatedAt")), 1),
                  _createVNode("div", _hoisted_61, _toDisplayString(_ctx.formatDateDetail(_ctx.dataDetail.updated_at)), 1),
                  _createVNode("div", _hoisted_62, _toDisplayString(_ctx.dataDetail.updated_by), 1)
                ]),
                _createVNode("div", _hoisted_63, [
                  _createVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("userManagement.detail.createdAt")), 1),
                  _createVNode("div", _hoisted_65, _toDisplayString(_ctx.formatDateDetail(_ctx.dataDetail.created_at)), 1),
                  _createVNode("div", _hoisted_66, _toDisplayString(_ctx.dataDetail.created_by), 1)
                ]),
                _createVNode("div", _hoisted_67, [
                  _createVNode(_component_lp_button, {
                    small: "",
                    onClick: _ctx.confirmationResetPassword,
                    "custom-class": "px-2 lg:px-8 whitespace-nowrap",
                    "icon-left": "lock-white",
                    title: _ctx.$t('userManagement.detail.resetPassword'),
                    "text-color": "white",
                    disabled: !_ctx.isAbleChangePassword
                  }, null, 8, ["onClick", "title", "disabled"])
                ])
              ])
            ])),
        (_ctx.modalEditDetail)
          ? (_openBlock(), _createBlock(_component_modal_edit_detail, {
              key: 2,
              type: _ctx.typeEdit,
              modelValue: _ctx.modalEditDetail,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.modalEditDetail = $event)),
              onSuccess: _ctx.fetchUserData
            }, null, 8, ["type", "modelValue", "onSuccess"]))
          : _createCommentVNode("", true)
      ], 64))
}